import { elem } from "./elem/elem.js";
import { jsml } from "./jsml.js";
import { ClassWatcher } from "./classWatcher.js";
import { retrieveComparisonIds } from "./integrateFilterCompare.js";
import { checkSelectedCount } from "./compare-counter.js";


// Define global props
const props = {
    'compare' : []
}

function activeSlotOnClassAdd() {

    if(checkSelectedCount() == 0) return;

    if(checkSelectedCount() > 1) {
        document.getElementById('compare-button').classList.add('active');
    } else {
        document.getElementById('compare-button').classList.remove('active');
    }
}

function activeSlotOnClassRemoval() { }


document.querySelectorAll('#compare-list li').forEach((compare) => {
    let classWatcher = new ClassWatcher(compare, 'active-slot', activeSlotOnClassAdd, activeSlotOnClassRemoval);
});

if(document.querySelector('.close-comparison-window')) {
    document.querySelector('.close-comparison-window').addEventListener('click', (e) => {
        document.getElementById('comparison-window').classList.remove('window-active');
        document.querySelector('body').classList.remove('comparison-window-active');
    });
}

document.querySelectorAll('#compare-list .clear').forEach((clear, index) => {
    clear.addEventListener('click', () => {
        retrieveComparisonIds(clear.parentElement.dataset.slotId);

    });
});

// ----------------------    Preloader ---------------------- //
// Pre-load existing data on to Slots
document.querySelectorAll('[data-compare]').forEach((compare, index) => {
    let i = 0;
    i = index + 1;

    if(window.sessionStorage.getItem('comparison_id_0' + i)) {
        compare.dataset.slotComparison = window.sessionStorage.getItem('comparison_meta_0' + i);
        compare.dataset.slotId = window.sessionStorage.getItem('comparison_id_0' + i);
        compare.dataset.type = window.sessionStorage.getItem('comparison_type_0' + i);
    
        if(window.sessionStorage.getItem('comparison_image_0' + i)) {
            compare.style.backgroundImage = `url(${window.sessionStorage.getItem('comparison_image_0' + i)})`;
        }
    }
});

// handle active slot / what happens when slot is clicked
const dataCompare = document.querySelectorAll('[data-compare]');
dataCompare.forEach((slot) => {
    slot.addEventListener('click', (e) => {
        e.preventDefault();
        
        
        dataCompare.forEach((slot) => {
            slot.classList.remove('active-slot');
        }); 
        
        slot.classList.add('active-slot');
    });
});

if(document.querySelector('a[href="#compare"]')) {
    // What happens wben the 'GO' button is clicked
    document.querySelector('a[href="#compare"]').addEventListener('click', (e) => {
        e.preventDefault();

        // Initiate compare pop-up window
        document.getElementById('comparison-window').classList.add('window-active');
        document.querySelector('body').classList.add('comparison-window-active');

        // Rebuild our props by calling our rebuild props function
        reBuildProps();

        let elemElement  = document.querySelector('#comparison-window > div');
        elemElement.innerHTML = '';
        
        // Loop around our props and build the comparison
        props.compare.forEach((item) => {
            
            // Create parent elements
            let parentContainer = document.createElement('div');
            parentContainer.classList.add('single-comparison');
            
            // Create our element to contain our elements
            let fragment = document.createDocumentFragment();

            // Image Tag
            let elemImg = document.createElement('img');
            elemImg.style = 'background-image: ' + item.backgroundImage + ';background-size:cover;background-repeat:no-repeat;';
            elemImg.classList.add('row-350','m-row-260','w-100');

            // Title Tag
            let elemTitle = document.createElement('h2');
            elemTitle.innerHTML = JSON.parse(item.meta).title;
            elemTitle.classList.add('ff-2','fs-40','i-gold','mv-40');

            fragment.appendChild(elemImg);
            fragment.appendChild(elemTitle);

            // List Item
            let elemMeta = document.createElement('ol');

           if(item.meta !== 'undefined') {
               
            
                let meta = JSON.parse(item.meta);

                Object.keys(meta).every(key => {
                    let elemMetaDetail = document.createElement('li');

                    elemMetaDetail.innerHTML = meta[key];
                    elemMeta.appendChild(elemMetaDetail);

                    return true;
                });
           }

           // Append to parent container
           fragment.appendChild(elemMeta);
           parentContainer.appendChild(fragment);
           elemElement.appendChild(parentContainer);

        });
    });
}

// ----------------------  On Slot Interaction ---------------------- //
// On Slot Click, Add to Local Storage + Move Data 
function slotSelector(slots) {
    slots.forEach((addToSlot) => {
        addToSlot.addEventListener('click', (e) => {

            let active = document.querySelector('.active-slot');
            let getDataCompare = document.querySelectorAll('[data-compare]');

            // If no active is detected, then ensure that the first-slot is set to active
            if(!active) {
                getDataCompare[0].classList.add('active-slot');
            }

            if(addToSlot.checked == false) {

                retrieveComparisonIds(addToSlot.dataset.slotId);
                active.classList.remove('active-slot');

                [...getDataCompare].every((compare) => {
                    if(compare.dataset.slotId) {
                        return true;
                    } else {
                        compare.classList.add('active-slot');
                        return false;
                    }
                });

                return;
            }

            if(active.dataset.slotId) {
                let detectCurrent = document.querySelector('#filter-results [data-slot-id="' + active.dataset.slotId + '"]')
                if(detectCurrent) {
                    detectCurrent.checked = false;
                }
            }

            if(active) {
                active.dataset.slotComparison = addToSlot.dataset.slotComparison;
                active.dataset.slotId = addToSlot.dataset.slotId;
                active.style.backgroundImage = `url(${addToSlot.dataset.slotImage})`;

                // Allow it to know its own relationship
                addToSlot.dataset.relationship = active.dataset.compare;

                // Set Local Storage Itom Comparison
                window.sessionStorage.setItem('comparison_meta_' + active.dataset.compare, addToSlot.dataset.slotComparison);
                window.sessionStorage.setItem('comparison_id_' + active.dataset.compare, addToSlot.dataset.slotId);
                window.sessionStorage.setItem('comparison_image_' + active.dataset.compare, addToSlot.dataset.slotImage);
                window.sessionStorage.setItem('comparison_type_' + active.dataset.compare, addToSlot.dataset.slotType);
                active.classList.remove('active-slot');

                if(active.nextSibling) {
                    if(active.nextSibling.dataset.slotId) {
                        active.nextSibling.nextSibling.classList.add('active-slot');
                    } else {
                        active.nextSibling.classList.add('active-slot');
                    }
                } else {

                    active.parentNode.children[0].classList.add('active-slot');
                }
            }
        });
    });
}

const dataCompare_EventListeners = () => {
    let addToSlots = document.querySelectorAll('#filter-results .add-to-slot');
    slotSelector(addToSlots);
    activeSlotOnClassAdd();
};

const dataCompare_EventListeners_Removal = () => {
    console.log('Class [filter-results-loaded] has been removed');
};

if (document.querySelector('#filter-results')) {
    let classWatcher = new ClassWatcher(
        document.getElementById('filter-results'), 
        'filter-results-loaded', 
        dataCompare_EventListeners, 
        dataCompare_EventListeners_Removal); 
}

// dataCompare_EventListeners();

// Retrieve data for Comparison Page + Retrieve the Data from Local Storage
function retrieveCompareData() {

    let i = 0;

    document.querySelectorAll('[data-comparison]').forEach((compare, index) => {
        i = index + 1;
        if(window.sessionStorage.getItem('comparison_id_0' + i)) {
            compare.dataset.slotComparison = window.sessionStorage.getItem('comparison_meta_0' + i);
            compare.dataset.slotId = window.sessionStorage.getItem('comparison_id_0' + i);
            compare.dataset.slotType = window.sessionStorage.getItem('comparison_type_0' + i);
            compare.style.backgroundImage = `url(${window.sessionStorage.getItem('comparison_image_0' + i)})`;
        }
    });     
}
retrieveCompareData();

// Function to build the Props Table
function reBuildProps() {

    let i = 0;
    props.compare = []; // reset compare props

    document.querySelectorAll('[data-comparison]').forEach((compare, index) => {
        i = index + 1;
        if(window.sessionStorage.getItem('comparison_id_0' + i)) {
            props.compare.push({ 
                'meta':  window.sessionStorage.getItem('comparison_meta_0' + i),
                'slotid' :  window.sessionStorage.getItem('comparison_id_0' + i),
                'backgroundImage' : `url(${window.sessionStorage.getItem('comparison_image_0' + i)})`
            });
        }
    }); 
}

// Rebuild props on pageload
reBuildProps();